
import { defineComponent, computed, watch , onMounted} from 'vue'
import { useBillingStore } from '../../../../store/stores/billing'
import { useProject } from '../../../../hooks/useProject'
import useRouter from '@/hooks/useRouter'
import { getSubscriptionPeriodSelectItems, resolveSubscriptionPeriod } from '../../subscriptionPeriodDiscount'
import { useTariffTrialRestrictions, TRIAL_DEFAULT_PERIOD } from '@/hooks/useTariffTrialRestrictions'

export default defineComponent({
    props: {},
    setup(props, { emit }) {
        const billingStore = useBillingStore()
        const { project } = useProject()
        const { route } = useRouter()
        const { isTrialRestricted } = useTariffTrialRestrictions()
        const tariffForPeriods = computed(() => billingStore.getTariffForPeriodLabels ?? null)
        // На пробном тарифе скрываем период «на месяц» и дефолтимся на 3 месяца (кроме суперпользователя).
        const periodResolveOptions = computed(() => ({
            excludeMonthly: isTrialRestricted.value,
            preferredFallback: isTrialRestricted.value ? TRIAL_DEFAULT_PERIOD : '12',
        }))
        const items = computed(() =>
            getSubscriptionPeriodSelectItems(tariffForPeriods.value, {
                excludeMonthly: isTrialRestricted.value,
            })
        )
        const currentTariff = computed(() => billingStore.getCurrentTariff(project.value.id))
        const update = (value: string) => {
            billingStore.selectedSubscriptionPeriod = value
        }
        const normalizeSelectedPeriod = () => {
            const normalized = resolveSubscriptionPeriod(
                billingStore.selectedSubscriptionPeriod,
                tariffForPeriods.value,
                periodResolveOptions.value
            )
            if (billingStore.selectedSubscriptionPeriod !== normalized) {
                billingStore.selectedSubscriptionPeriod = normalized
            }
        }
        const setDefaultPeriod = () => {
            if (billingStore.selectedSubscriptionPeriod) {
                normalizeSelectedPeriod()
                return
            }
            const queryPeriod = String(route.value?.query?.period || '')
            if (queryPeriod && items.value.some(item => item.value === queryPeriod)) {
                billingStore.selectedSubscriptionPeriod = queryPeriod
            } else if (currentTariff.value?.periodInMonths && !currentTariff.value?.isTrial) {
                billingStore.selectedSubscriptionPeriod = currentTariff.value.periodInMonths.toString()
            } else {
                billingStore.selectedSubscriptionPeriod = resolveSubscriptionPeriod(
                    null,
                    tariffForPeriods.value,
                    periodResolveOptions.value
                )
            }
            normalizeSelectedPeriod()
        }
        watch(currentTariff, setDefaultPeriod)
        watch(() => billingStore.selectedTariffId, normalizeSelectedPeriod)
        watch(() => billingStore.selectedSubscriptionPeriod, normalizeSelectedPeriod)
        onMounted(() => {
            setDefaultPeriod()
        })
        return { items, update, billingStore }
    },
})
